document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');
    const readMoreButton = document.querySelector('#see-more-less-btn');
    const dataItemsValue = document.querySelector('.faq--wrapper')?.getAttribute('data-items');
    const itemsToShow = parseInt(dataItemsValue, 10) || 8; // Default to 8 items if data-items is not set
    let isExpanded = false; // To track the state of "See More" and "See Less"

    // Function to manage visibility of FAQ items
    function updateFaqVisibility() {
        let visibleCount = 0;
        faqItems.forEach(item => {
            if (visibleCount < itemsToShow || isExpanded) {
                item.style.display = 'block'; // Show item
                visibleCount++;
            } else {
                item.style.display = 'none'; // Hide item
            }
        });
    }

    function updateReadMoreButton() {
        if (faqItems.length > itemsToShow) {
            readMoreButton.style.display = 'flex';
            readMoreButton.innerHTML = isExpanded 
                ? 'عرض أقل <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.4198 10.6574L11.5 1C9.08103 1.02348 4.26149 1.05662 1.84249 1.0801L1.82263 2.28911C3.99837 2.26774 6.88675 2.25 9.42771 2.22695L1.5 10.1546L2.34547 11.0001L10.2732 3.07239L10.2044 10.6709L11.4198 10.6574Z" fill="#414141" stroke="#414141"></path></svg>'
                : 'عرض المزيد <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.4198 10.6574L11.5 1C9.08103 1.02348 4.26149 1.05662 1.84249 1.0801L1.82263 2.28911C3.99837 2.26774 6.88675 2.25 9.42771 2.22695L1.5 10.1546L2.34547 11.0001L10.2732 3.07239L10.2044 10.6709L11.4198 10.6574Z" fill="#414141" stroke="#414141"></path></svg>';
        } else {
            readMoreButton.style.display = 'none';
        }
    }

    if (readMoreButton) {
        readMoreButton.addEventListener('click', () => {
            isExpanded = !isExpanded;
            updateFaqVisibility();
            updateReadMoreButton();
        });
    }

    updateFaqVisibility();
    updateReadMoreButton();
});

let faqQuestions2 = document.querySelectorAll(".faq-question");
faqQuestions2.forEach(question2 => {
    question2.addEventListener("click", event => {
        const active = document.querySelector(".faq-question.active");
        if (active && active !== question2) {
            active.classList.toggle("active");
            active.nextElementSibling.style.maxHeight = 0;
            active.nextElementSibling.classList.remove("open-accordian");
            active.parentElement.classList.remove("active-faq-item");
        }
        question2.classList.toggle("active");
        const answer = question2.nextElementSibling;
        const parent = question2.parentElement;
        if (question2.classList.contains("active")) {
            answer.style.maxHeight = answer.scrollHeight + "px";
            answer.classList.add("open-accordian");
            parent.classList.add("active-faq-item");
        } else {
            answer.style.maxHeight = 0;
            answer.classList.remove("open-accordian");
            parent.classList.remove("active-faq-item");
        }
    });
});
